import React, { Component } from 'react';
import classnames from 'classnames';

import { cancel, deleteVideo } from '../../../actions';
import Textarea from 'react-textarea-autosize';
import FaExclamationTriangle from 'react-icons/lib/fa/exclamation-triangle';

import './videoItem.css';
import '../../../misc/rc-checkbox.css';

import DraggableVideoCard from 'src/app/dnd/video-card';

export default class GridItem extends Component {
  constructor() {
    super();
  }

  render() {
    const {
      props,
      toggleDeleteModal,
      toggleSelect,
      toggleEmbedModal,
      togglePrivacyModal,
      toggleFileListModal,
      children,
    } = this.props;

    const { video, userTier, handleEditLabelsClick } = props;

    // override this here because we don't want it to adjust size on change, only on props change
    function textAreaChange(e) {
      this.props.onChange(e);
    }
    Textarea.prototype._onChange = textAreaChange;

    return (
      <div
        className={classnames(
          'col-md-6',
          'col-sm-12',
          'col-xl-4',
          'col-12',
          'grid',
          'video-item',
          {
            reorderable: props.reorderable,
            selected: props.selected,
          }
        )}
      >
        {video.flagged == 1 ? (
          <div className="error-alert">
            <FaExclamationTriangle />
            <p>
              This video has been removed for violating our{' '}
              <a
                href="https://streamable.com/community-guidelines"
                target="_blank"
                referrerPolicy="no-referrer"
              >
                Community Guidelines
              </a>
              .
            </p>
            <button
              onClick={(e) => {
                props.dispatch(deleteVideo(video));
              }}
            >
              Dismiss
            </button>
          </div>
        ) : video.flagged == 2 ? (
          <div className="error-alert">
            <FaExclamationTriangle />
            <p>
              This video has been disabled due to a claim of copyright
              infringement. You can dismiss this notice or review options set
              out in our{' '}
              <a
                href="https://streamable.com/community-guidelines"
                target="_blank"
                referrerPolicy="no-referrer"
              >
                Community Guidelines
              </a>
              .
            </p>
            <div>
              <button
                onClick={(e) => {
                  props.dispatch(deleteVideo(video));
                }}
              >
                Dismiss
              </button>
              &nbsp;
              <button
                onClick={(e) => {
                  window.open(
                    'https://hopin.com/legal/community-guidelines',
                    '_blank'
                  );
                }}
              >
                Review Options
              </button>
            </div>
          </div>
        ) : video.status == 3 ? (
          <div className="error-alert">
            <FaExclamationTriangle />
            <p dangerouslySetInnerHTML={{ __html: video.error }}></p>
            <button
              onClick={(e) => {
                props.dispatch(cancel(video, 'griditem'));
              }}
            >
              OK
            </button>
          </div>
        ) : (
          <div>
            {children}
            <div className="card-container">
              <DraggableVideoCard
                handleEditLabelsClick={handleEditLabelsClick}
                selected={props.selected}
                toggleDeleteModal={toggleDeleteModal}
                toggleEmbedModal={toggleEmbedModal}
                toggleFileListModal={toggleFileListModal}
                togglePrivacyModal={togglePrivacyModal}
                toggleSelect={toggleSelect}
                userTier={userTier}
                video={video}
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}
